import React, { useEffect } from 'react';
import { useLocation } from 'wouter';
import ReactGA from 'react-ga';

const trackPage = (page) => {
  ReactGA.set({
    page,
  });
  ReactGA.pageview(page);
};

const withTracker = (WrappedComponent) => {
  const Tracker = () => {
    const [location] = useLocation();

    useEffect(() => {
      trackPage(location);
    }, [location]);

    return <WrappedComponent />;
  };

  return Tracker;
};

export default withTracker;
